<template>
  <section class="index" js-page="index">
    <div
      class="index__hover-sec"
      js-position="left"
      @mousemove="hoverSections"
      @mouseleave="removeClass"
    ></div>
    <div
      class="index__hover-sec"
      js-position="right"
      @mousemove="hoverSections"
      @mouseleave="removeClass"
    ></div>

    <div class="events">
      <EventList
        v-for="(event, index) in eventsList[lang]"
        :key="event.id"
        :event="event"
        :class="index === eventsList[lang].length - 1 ? 'last' : false"
      />
    </div>

    <Cta
      :btn="btn"
      js-refPage="index"
      class="btn-js btn--download"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { TimelineLite, TweenLite, TweenMax, Elastic, Power2 } from 'gsap/TweenMax';

import store from '@/store';

import DragImage from '@/scripts/DragImage';
import animations from '@/scripts/animations';
import { qs, qsa, isMobile } from '@/scripts/utils';

import EventList from '@/components/EventList';
import Cta from '@/components/utils/Cta';


export default {
  name: 'Index',

  components: {
    EventList,
    Cta,
  },

  data() {
    return {
      ready: false,
      enterDone: false,
      isMobile,
      animationMus: null,
      classMouse: null,

      btn: {
        it: {
          textPrimary: 'scarica programma',
          textAlt: false,
        },

        en: {
          textPrimary: 'download schedule',
          textAlt: false,
        },

        symbol: 'download',

        link: `https://festival.bersiserlini.it/static/pdf/BersiSerlini-FestivalFranciacorta2018-${store.getters.getLang}.pdf`,
        external: true,
      },
    };
  },

  watch: {
    lang(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$nextTick(() => {
          qs('.events', this.$el).classList.add('animating');

          const animateText = animations.get('eventsListIn')(qsa('[js-anim="eventsList"]', this.$el));
          animateText.play();

          this.btn.link = `https://festival.bersiserlini.it/static/pdf/BersiSerlini-FestivalFranciacorta2018-${newVal}.pdf`;
        });
      }
    },

    mouseDown(newVal, oldVal) {
      if (newVal && this.ready && !this.enterDone && !isMobile()) {
        this.enterDone = true;
        this.dragImage.bindEvents();

        this.animationMuselet.play();

        const classMouse = `${this.o}-drag`;
        this.cursor.classList.replace(this.classMouse, classMouse);
        this.classMouse = classMouse;
      } else if (!newVal && oldVal && this.ready && this.enterDone && !isMobile()) {
        this.dragImage.unbindEvents();

        document.querySelector('.cursor-hover').style.fill = '#ffd300';
        document.querySelector('.cursor-hover').style.stroke = '#ffd300';

        this.animationMuselet.reverse();
        this.enterDone = false;

        const classMouse = `${this.o}-hold`;
        this.cursor.classList.replace(this.classMouse, classMouse);
        this.classMouse = classMouse;
      }
    },
  },

  computed: {
    ...mapGetters({
      eventsList: 'getEventsList',

      lang: 'getLang',

      mouseDown: 'getMouseDown',
    }),

    checkWidth() {
      const val = window.innerWidth > 1000;
      return val;
    },
  },

  created() {
    if (!this.isMobile()) this.$store.commit('SET_HOVEREVENT', false);
    this.animationMus = () => this.animationMuselet();
  },

  mounted() {
    TweenLite.set('.events', { autoAlpha: 0 });
    if (!isMobile()) {
      qs('.events', this.$el).classList.add('animating');
      TweenMax.to('.composition-cont', 1, { autoAlpha: 0 });

      this.$store.commit('ADD_BUTTONS', this.$el);
      if (!this.isMobile()) {
        this.dragImage = new DragImage();
        this.dragImage.init(this.$el);
      }

      setTimeout(() => {
        this.ready = true;
      }, 5200);

      this.animationMuselet = new TimelineLite({ paused: true });
      this.animationMuselet.add('start')
        .to('.index', 0.6, { autoAlpha: 0, ease: Power2.easeOut }, 'start')
        .to('.muselet__dot', 1, { scale: 1.2, ease: Elastic.easeOut.config(0.8, 1) }, 'start+=0.1')
        .to('.composition-cont', 1, { autoAlpha: 1, ease: Power2.easeOut }, 'start+=0.4')
        .to('.logo', 0.8, { autoAlpha: 1, ease: Power2.easeOut }, 'start+=0.6');
    } else {
      // TweenLite.to('.muselet__dot', 1,
      // { scale: 1.2, ease: Elastic.easeOut.config(0.8, 1), delay: 0.6 });
      TweenLite.to('.logo', 0.8, { autoAlpha: 0, ease: Power2.easeOut, delay: 0.1 });
    }

    this.cursor = document.querySelector('.cursor');
  },

  methods: {
    hoverSections(event) {
      if (window.innerWidth < 1024) return;

      this.o = event.target.getAttribute('js-position');
      const classMouse = (this.$store.state.mouseDown) ? `${this.o}-drag` : `${this.o}-hold`;

      if (this.cursor.classList.contains(this.classMouse)) {
        this.cursor.classList.replace(this.classMouse, classMouse);
      } else {
        this.cursor.classList.add(classMouse);
      }

      this.classMouse = classMouse;
    },

    removeClass() {
      this.cursor.classList.remove(this.classMouse);
    },
  },

  beforeDestroy() {
    const els = qsa('.index__hover-sec', this.$el);
    els.forEach(el => el.style.pointerEvents = 'none'); // eslint-disable-line
    if (this.cursor.classList.contains(this.classMouse)) this.cursor.classList.remove(this.classMouse); // eslint-disable-line
    if (!this.isMobile()) this.dragImage.destroy();
  },
};
</script>

<style lang="scss" scoped>
@import '../application';

.index {
  @extend %flex;

  max-width: 100%;

  margin: 0 auto;

  padding: 104px 0 77px 0;

  @include mq(sm) {
    max-width: 700px;
    width: 80%;
    padding: 0;
    justify-content: flex-end;
  }

  @include mq(md) {
    width: auto;
    max-width: 900px;
  }

  .index__hover-sec {
    display: none;
    visibility: hidden;

    @include mq(md) {
      display: block;
      visibility: visible;

      position: fixed;
      top: 0;
      width: calc((100vw - 920px) / 2);
      height: 100%;

      &[js-position="left"] {
        left: 0;
      }

      &[js-position="right"] {
        right: 0;
      }
    }
  }

  // @include mq(lg) {
  //   max-width: 1040px;
  // }

  // @media (max-height: 650px) {
  //   padding: 104px 0 77px 0;
  // }

  -webkit-touch-callout: none;
  -webkit-user-select: none;
   -khtml-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.events {
  position: relative;
  overflow: hidden;
  padding: 0;

  @include mq(sm) {
    text-align: justify;
  }

  @include mq(sm) {
    padding: $margin 0 0;
  }

  @include mq(lg) {
    padding: 30px 0 0;
  }

  &.animating {
    pointer-events: none;
  }
}

.btn--download {
  position: relative;
  margin: 0;

  z-index: 1;

  @include mq(md) {
    margin: $margin*1.5 0 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index.vue